import {
  Card,
  Space,
  Table,
  Input,
  Form,
  Button,
  Drawer,
  Modal,
  Descriptions,
  Pagination,
} from 'antd';
import { useContext } from 'react';
import CreateDrawer from '../../../components/create';
import { PageContext } from '../../../lib/context';
import ReadingTable from './reading-table';
import MeterEditForm from './form';
import moment from 'moment';
import { CSVLink, CSVDownload } from 'react-csv';
import confirm from 'antd/lib/modal/confirm';
import Loading from '../../../components/loader';

const drawerColumns = [
  {
    title: '',
    data: 'color',
    key: 'color',
    render: (color: any) => (
      <div
        className="h-4 w-4 rounded-full"
        style={{ backgroundColor: color.color }}
      ></div>
    ),
  },
  {
    title: 'Meter ID',
    key: 'serial_number',
    render: (val: any) => (
      <a href={`/meters/${val?.id}`} target="_blank">
        {val?.serial_number}
      </a>
    ),
  },
  {
    title: 'Name',
    key: 'name',
    dataIndex: 'name',
  },
  {
    title: 'Address',
    key: 'complete_address',
    dataIndex: 'complete_address',
  },
  {
    title: 'Reading Date/Time',
    dataIndex: 'reading_date',
    key: 'reading_date',
    render: (val: Date) => moment(val).format('LLL'),
  },
  {
    title: 'Reading',
    dataIndex: 'meter_reading',
    key: 'meter_reading',
  },
  {
    title: 'Info',
    dataIndex: 'message',
    key: 'message',
  },
];

const MeterView = () => {
  const {
    columns,
    color_count,
    meters,
    showForm,
    _submitHandler,
    _onFinishSearch,
    color,
    setColor,
    meterColors,
    _openDrawer,
    showDrawer,
    setShowDrawer,
    csv: csvData,
    _refreshDrawer,
    addReading,
    setAddReading,
    readingForm,
    _confirmReading,
    current,
    color_loading,
    meter_loading,
    limit,
    offset,
    total,
    currentPage,
    handlePaginationChange,
    limitColor,
    offsetColor,
    totalColor,
    currentPageColor,
    handlePaginationChangeColor,
    closeDrawer,
    handleSort,
  } = useContext(PageContext);
  return (
    <div className="flex flex-col px-10">
      <div className="items-start align-start">
        <p className="text-3xl font-bold">Meters</p>
      </div>
      {/* button */}
      <div className="flex flex-row mb-5">
        <Space>
          <CreateDrawer
            title={showForm ? 'Add/Edit Meter' : 'Meter Reading'}
            buttonTitle="Add Meter"
            _submitHandler={_submitHandler}
            addForm={true}
          >
            {showForm ? <MeterEditForm /> : <ReadingTable />}
          </CreateDrawer>
        </Space>
      </div>
      {/* <div className="flex flex-row">
        <Space>
          <div className="flex flex-row">
            <div className="mr-20">
              <Input.Search
                placeholder="Search Meter by Serial Number"
                style={{ width: 500 }}
                enterButton
                onSearch={handleSearch}
                allowClear
                size="large"
              />
            </div>
          </div>
        </Space>
      </div> */}
      {/* <div className="flex flex-row">
        <Card
          style={{
            borderRadius: 20,
            flexDirection: 'row',
            height: 300,
            width: 600,
            marginRight: 20,
            display: 'none',
          }}
        >
          <div className="flex flex-row">
            <div className="mr-20">
              <p className="font-bold">Meter Stats</p>
              <p className="text-xl font-bold">+120 today</p>
              <p className="text-xl font-bold">+420 this week</p>
              <p className="text-xl font-bold">+970 this month</p>
            </div>
            <div style={{ height: 230, width: 230 }}></div>
          </div>
        </Card>
      </div> */}
      <div className="pt-5">
        <Form layout="inline" onFinish={_onFinishSearch}>
          <Form.Item name="serial_number">
            <Input
              placeholder="Search by Meter ID"
              style={{ width: 300 }}
              allowClear
              size="large"
            />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" size="large">
              Search
            </Button>
          </Form.Item>
        </Form>
      </div>
      <div className="flex justify-end">
        <div
          className="text-green-500 mx-1 font-semibold cursor-pointer"
          onClick={() => _openDrawer('green')}
        >
          Connected ({color_count?.green?.aggregate?.count}) |{' '}
        </div>
        <div
          className="text-purple-500 mx-1 font-semibold cursor-pointer"
          onClick={() => _openDrawer('purple')}
        >
          Not Assigned ({color_count?.purple?.aggregate?.count}) |{' '}
        </div>
        <div
          className="text-yellow-500 mx-1 font-semibold cursor-pointer"
          onClick={() => _openDrawer('orange')}
        >
          Not Reporting ({color_count?.orange?.aggregate?.count}) |{' '}
        </div>
        <div
          className="text-black mx-1 font-semibold cursor-pointer"
          onClick={() => _openDrawer('black')}
        >
          More than 1 week not reporting ({color_count?.black?.aggregate?.count}
          ) |
        </div>
        <div
          className="text-gray-500 mx-1 font-semibold cursor-pointer"
          onClick={() => _openDrawer('grey')}
        >
          |More than 48 hours not reporting (
          {color_count?.grey?.aggregate?.count}) |
        </div>
        <div
          className="text-indigo-500 mx-1 font-semibold cursor-pointer"
          onClick={() => _openDrawer('location')}
        >
          Without Location ({color_count?.no_location?.aggregate?.count})
        </div>
      </div>
      <div className="flex flex-row mt-5">
        <div className="w-full mr-3">
          {meter_loading ? (
            <Loading show={meter_loading} />
          ) :
            (
              <>
                <Table dataSource={meters} columns={columns} pagination={false} onChange={handleSort} />
                <Pagination
                  onChange={handlePaginationChange}
                  total={total}
                  current={currentPage}
                  pageSize={limit}
                />
              </>
            )
          }
        </div>
      </div>
      <Drawer
        width="100%"
        visible={showDrawer}
        title="Meters"
        onClose={() => setShowDrawer(false)}
        footer={
          <div>
            <Button type="primary" onClick={closeDrawer}>
              Close
            </Button>
          </div>
        }
      >
        <div className="my-2 text-white bg-blue-700 rounded inline-block p-2 cursor-pointer">
          <CSVLink data={csvData} className="tex-white" filename="Report.csv">
            DOWNLOAD CSV FILE
          </CSVLink>
        </div>
        <div className="inline-block my-2 px-2">
          <Button style={{ height: 38 }} onClick={_refreshDrawer}>
            Refresh
          </Button>
        </div>
        {color_loading ? (
          <Loading show={color_loading} />
        ) :
          (
            <>
              <Table columns={drawerColumns} dataSource={meterColors} pagination={false} />
              <Pagination
                onChange={handlePaginationChangeColor}
                current={currentPageColor}
                total={totalColor}
                pageSize={limitColor}
              />
            </>
          )
        }
      </Drawer>
      <Modal
        title="Add New Reading"
        visible={addReading}
        onCancel={() => setAddReading(false)}
        closable
        onOk={() =>
          confirm({
            content: 'Press OK to confirm.',
            onOk() {
              readingForm.submit();
            },
          })
        }
        width={1000}
      >
        <Descriptions column={2} bordered>
          <Descriptions.Item label="Meter ID">
            {current?.serial_number}
          </Descriptions.Item>
          <Descriptions.Item label="Subscriber">
            {`${current?.subscribers?.[0]?.first_name} ${current?.subscribers?.[0]?.last_name}`}
          </Descriptions.Item>
          <Descriptions.Item label="Latest Reading Date">
            {moment(current?.meter_readings?.[0]?.date_time).format('LL')}
          </Descriptions.Item>
          <Descriptions.Item label="Latest Reading Value">
            {current?.meter_readings?.[0]?.value}
          </Descriptions.Item>
        </Descriptions>
        <Form
          form={readingForm}
          onFinish={_confirmReading}
          layout="vertical"
          style={{ marginTop: 20 }}
        >
          <Form.Item
            name="reading"
            label="Current Reading"
            rules={[{ required: true, message: 'Latest reading is required' }]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default MeterView;
